import { CirclePlus } from "lucide-react";
import { default as ReactSelect, components } from "react-select";
import { toast } from "react-toastify";
import GuestIcon from "../../assets/icons/GuestIcon";
import { useNavigate } from "react-router-dom";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import ImageIcon from "./ImageIcon";
const CustomMenuList = (props: any) => {
  const navigate = useNavigate();
  const { events }: DictionaryType = useGetDictionary();
  return (
    <components.MenuList {...props}>
      {/* Action Button */}
      <div
        className="flex flex-col  "
        style={{ borderBottom: "1px solid #ccc" }}
      >
        {props.hasGuestPlayer && (
          <button
            className=" flex gap-2 py-2 px-2 text-primary text-sm  w-full hover:bg-[#1e185066] hover:text-white "
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              props.addGuestPlayer();
              //toast.warn('These features are coming soon. Stay in touch with our support team! 😊');
              // or call a callback: props.selectProps.onAddNewPlayer();
            }}
          >
            {/* <GuestIcon className="hover:text-white" width={"20px"} />{" "} */}
            <ImageIcon
              className=" transition-none"
              width={20}
              Icon={GuestIcon}
            />
            <span>Add Guest Player {props.query && `"${props.query}"`}</span>
          </button>
        )}
        {props.hasAddPlayerBtn && (
          <button
            className="flex gap-2 py-2 px-2 text-primary text-sm  w-full hover:bg-[#1e185066] hover:text-white "
            onClick={() => {
              navigate(`/club-settings/customer/new?title=add new customer`, {
                state: {
                  title: "return Back ",
                  action_type: props.action_type,
                  type: props.type,
                  booking_id: props.booking_id || null,
                },
              });
            }}
          >
            <ImageIcon
              className=" transition-none"
              width={20}
              Icon={GuestIcon}
            />{" "}
            Add New Player
          </button>
        )}
      </div>
      {/* Default Options */}
      {props.children}
    </components.MenuList>
  );
};
export default CustomMenuList;
